import React, { useEffect, useState } from "react";
import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import styles from "../styles/global-styles";
import CategorySelect from "../components/shared/selects/CategorySelect";
import SubcategorySelect from "../components/shared/selects/SubcategorySelect";
import BrandSelect from "../components/shared/selects/BrandSelect";
import ModelSelect from "../components/shared/selects/ModelSelect";
import ChipCategorySelect from "../components/shared/selects/ChipCategorySelect";
import ComparativeTable from "../components/core/inventory/comparative/ComparativeTable";
import { ProductService } from "../services/product.service";
import { actions } from "../redux/actions/alert";
import { connect } from "react-redux";
import { removeDuplicateSitesInProducts } from "../_utils/utils";
import CardCategorySelect from "../components/shared/selects/CardCategorySelect";

const useStyles = makeStyles(() => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
}));

const ContainerProductComparative = ({ addAlert, detailAlert }) => {
  const classes = useStyles();

  const [queryParams, setqueryParams] = useState({});
  const [productArray, setProductArray] = useState([]);
  const [filterProductArray, setFilterProductArray] = useState([]);

  useEffect(() => {
    if (productArray.length) {
      (async function () {
        try {
          const uniqueList = removeDuplicateSitesInProducts(
            productArray,
            queryParams.productTypeId
          );
          console.log("uniqueListArray", uniqueList);
          /** Retrieve for each site total products */
          for (const [index, item] of uniqueList.entries()) {
            const body = {
              ...queryParams,
              inDistribution: 0,
              productSold: 0,
              siteId:
                item.movile?.siteId ||
                item.accesory?.siteId ||
                item.chip?.siteId ||
                item.cash_card?.siteId,
            };
            if (queryParams.productTypeId === 1) {
              const { data } = await ProductService.countMovilesInSingleSite(
                body
              );
              uniqueList[index].quantity = data;
            } else if (queryParams.productTypeId === 2) {
              const { data } = await ProductService.countAccesoriesSingleSite(
                body
              );
              uniqueList[index].quantity = data;
            } else if (queryParams.productTypeId === 3) {
              const { data } = await ProductService.countChipsSingleSite(body);
              uniqueList[index].quantity = data;
            } else {
              const { data } = await ProductService.countCashCardsInSingleSite(
                body
              );
              uniqueList[index].quantity = data;
            }
            // uniqueList[index].quantity = resp.data;
          }
          setFilterProductArray(uniqueList);
        } catch (error) {
          addAlert({ showAlert: true });
          detailAlert({
            severity: "error",
            message: error.msgs || "Error al procesar tu solicitud",
          });
        }
      })();
    }
  }, [productArray]);

  /**Clean all selects */
  useEffect(() => {
    setqueryParams({ productTypeId: queryParams.productTypeId });
  }, [queryParams.productTypeId]);

  const handleQuerySelected = (key, value) => {
    setqueryParams({ ...queryParams, [key]: value === "none" ? "" : value });
  };

  const searchProductByFilters = async () => {
    const body = { ...queryParams, inDistribution: 0, productSold: 0 };
    try {
      let productResponse = [];
      const error = {
        noProduct: "No se encontraron productos con los filtros seleccionados",
      };
      /** Validate type of product and call ProductService */
      if (queryParams.productTypeId === 1) {
        const { data } = await ProductService.getProductByMovilesWithParams(
          body
        );
        productResponse = data;
      } else if (queryParams.productTypeId === 2) {
        const { data } = await ProductService.getProductByAccesoriesWithParams(
          body
        );
        productResponse = data;
      } else if (queryParams.productTypeId === 3) {
        const { data } = await ProductService.getProductByChipsWithParams(body);
        productResponse = data;
      } else {
        const { data } = await ProductService.getProductByCashCardWithParams(
          body
        );
        productResponse = data;
      }
      if (productResponse.length) setProductArray(productResponse);
      else throw error;
    } catch (error) {
      console.log("error", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: error.noProduct ? "warning" : "error",
        message: error.noProduct
          ? error.noProduct
          : error.msgs || "Error al procesar tu solicitud",
      });
    }
  };

  const validateQueryParams = () => {
    if (queryParams.productTypeId) {
      const paramsValidated = Object.values(queryParams).filter(
        (value) => value !== ""
      );
      switch (queryParams.productTypeId) {
        case 1:
          return paramsValidated.length === 3 ? false : true;
        case 2:
          return paramsValidated.length === 4 ? false : true;
        case 3:
          return paramsValidated.length === 2 ? false : true;
        case 4:
          return paramsValidated.length === 2 ? false : true;
        default:
          return false;
      }
    } else return true;
  };

  return (
    <>
      <Typography variant="h4" component="h4" className={classes.title}>
        Comparar Inventario
      </Typography>

      <Grid
        container
        direction="row"
        justify="space-evenly"
        alignItems="center"
      >
        <Grid item>
          <CategorySelect category={handleQuerySelected} showAll={false} />
        </Grid>

        {queryParams.productTypeId === 1 && (
          <Grid item>
            <BrandSelect hideAllOption brand={handleQuerySelected} isMovile />
          </Grid>
        )}

        {queryParams.productTypeId === 2 && (
          <Grid item>
            <BrandSelect hideAllOption brand={handleQuerySelected} />
          </Grid>
        )}

        {queryParams.brand &&
          queryParams.brand !== "" &&
          queryParams.model !== "" && (
            <Grid item>
              <ModelSelect
                brand={queryParams.brand}
                model={handleQuerySelected}
                isMovile={queryParams.productTypeId === 1}
              />
            </Grid>
          )}

        {queryParams.productTypeId === 2 && (
          <Grid item>
            <SubcategorySelect formOption subcategory={handleQuerySelected} />
          </Grid>
        )}

        {queryParams.productTypeId === 3 && (
          <ChipCategorySelect hideAllOption category={handleQuerySelected} />
        )}

        {queryParams.productTypeId === 4 && (
          <CardCategorySelect
            hideAllOption
            cardCategory={handleQuerySelected}
          />
        )}

        {}
        <Grid item>
          <Button
            style={{ marginTop: 20 }}
            className={classes.rightButton}
            variant="contained"
            disabled={validateQueryParams()}
            onClick={searchProductByFilters}
            color="primary"
            endIcon={<SearchIcon color="secondary" />}
          >
            Filtrar
          </Button>
        </Grid>
      </Grid>

      {filterProductArray.length > 0 && (
        <ComparativeTable filterProductArray={filterProductArray} />
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(ContainerProductComparative);
